<template>
  <div class="terms">
    <main class="full">
      <h1 class="underline-gray">スマートソン利用規約(参画企業)[フリープラン]</h1>
      <p>
        本規約は、株式会社prd(以下「当社」といいます。)が提供するサービス「スマートソン」(以下「本サービス」といいます。)の利用において会社情報、採用情報、イベント情報等の情報を本サービスに登録する学生ユーザー(以下「会員」といいます。)へ配信することを希望する事業者(以下「参画企業」といいます。)の利用条件を定めるものです。参画企業と当社が本サービスのサイト上で定める「フリープラン」での利用契約を締結する場合、本規約の諸条項は、当該利用契約の内容となります。 <br>
         <br>
        第１条（定義） <br>
        本契約に定める用語の定義は、特別の定めがある場合を除き、次の各号のとおりとします。 <br>
        (1)  会員：本サービスに登録した学生等 <br>
        (2) スマートソンスワイプ：参画企業の提供する情報をカード化し、会員が閲覧し「興味の有無」を判断する機能 <br>
        (3) スワイプカード：スマートソンスワイプ上で表示される参画企業の提供する情報を含むカード <br>
        (4) インターン逆求人：インターン逆求人：会員の「やりたい」を起点にマッチングを実現する逆求人機能 <br>
         <br>
        第２条（登録申請） <br>
        1. 本サービスを参画企業として利用するには、本サイト上で本サービスのアカウント登録申請手続きを行い、当社との間で本サービスの利用契約(以下「本利用契約」といいます。)を締結する必要があります <br>
        2. 参画企業が、本サイト上で本サービスのアカウント登録申請手続きを行った場合、その時点で、参画企業と当社との間で、本規約の諸条項に従った本利用契約が成立するものとします。この場合において、参画企業は、本規約の内容を理解しており、かつ、本規約のすべての条項について承諾したものとみなします。 <br>
         <br>
        第３条（登録審査） <br>
        1. 当社は、参画企業からアカウント登録申請があった場合、当社が別途定めた審査基準により登録審査を行います。 <br>
        2. 前項の登録審査が完了するまでの間、参画企業はスワイプカードの配信が行えないなど、本サービスの一部の利用が制限されます。 <br>
        3. 当社は、参画企業が、第1項の審査基準を満たさないと判断した場合には、登録申請を却下することができます。この場合、参画企業はその時点以降、本サービスを利用することができません。 <br>
        4. 当社が登録申請を却下する場合であっても、参画企業への通知は必要ありません。また、当社は、登録申請を却下した理由を参画企業に開示する義務を負いません。 <br>
         <br>
        第４条（利用条件の変更） <br>
        1. 当社は、いつでも本サービスについての利用条件(以下総称して「利用条件」という。)を変更することができるものとします。変更後の利用条件は、当社が別途定める場合を除いて、当社のウェブサイトに掲示された時点又は当社が別途指定する方法により参画企業に対する通知を送付した時点より効力を生じます。 <br>
        2. 参画企業が利用条件の変更後も本サービスの利用を継続する場合、参画企業は、変更後の利用条件に同意したものとみなすものとします。 <br>
         <br>
        第５条（本サービスの利用） <br>
        1. 参画企業は、当社が定め又は指示する方法に従い、本サービスを利用することができるものとします。 <br>
        2. 本サービスの内容は当社が別途当社の運営するウェブサイト等において定めるものとします。 <br>
         <br>
        第６条（アカウントの管理） <br>
        1. 参画企業は、自己の責任において、本サービスのアカウントにログインするためのメールアドレス及びパスワードを管理するものとします。 <br>
        2. 参画企業は、いかなる場合でも、第三者に自己の本サービスのアカウントを利用させることはできません。 <br>
        3. 参画企業は、本サービスの利用にあたって当社に申請した事実に変更が生じた場合には、すみやかに、本サイトを通じて、当該変更の内容について当社に申請するものとします。 <br>
        4. 当社は、参画企業以外の第三者が参画企業のメールアドレス及びパスワードを用いて本サービスにログインした場合には、当該第三者による利用を、そのメールアドレスを登録している参画企業自身による利用とみなすことができるものとします。 <br>
        5. 参画企業は、参画企業の担当者に本サービスを利用させる場合、当該役職員等をして、前項の義務その他の本契約上の義務を遵守させるものとし、役職員等が本契約上の義務に違反した場合は、参画企業が本契約に違反したものとみなします。 <br>
        6. 本契約が終了した場合、当社は直ちに本条に定めるアカウントを削除することができ、当該削除によって参画企業に損害が生じた場合であっても当社は一切責任を負わないものとします。 <br>
         <br>
        第７条（権利譲渡の禁止） <br>
        参画企業は、本契約から生ずる権利又は義務を当社による承諾なく第三者に譲渡、または担保の目的に供してはなりません。 <br>
         <br>
        第８条（権利の帰属） <br>
        1. 本サービス及び本サービス上で提供されるコンテンツ(以下「提供コンテンツ」という。)に関する一切の知的財産権は、当社又は当社にライセンスを許諾している者に帰属するものとし、参画企業は本サービス及び提供コンテンツを逆アセンブル、逆コンパイル、リバースエンジニアリング、複製、変更、改変等しないものとします。 <br>
        2. 参画企業は、当社が本サービスの宣伝、プロモーション等の広報営業活動、又は本サービスの円滑な提供、改良、メンテナンスを行うために必要な範囲内において、参画企業が当社に提供し又は本サービスに掲載した文章、写真、動画等の著作物、商標等を利用(二次利用や乙が指定する第三者への利用許諾を含みます。)することを本サービスへの情報の掲載時において、当社に対し、無償で、期間及び地域の限定なく、非独占的に許諾するものとし、参画企業は当社及び当社の指定する者に対して著作者人格権を行使しないものとします。 <br>
         <br>
        第９条（保証の否認及び免責） <br>
        1. 当社は、本サービス及び本サービスを通じて提供されるコンテンツその他一切の情報の内容に関して、参画企業の特定の目的への適合性、商品的価値、正確性、有用性、完全性、適法性、参画企業に適用のある団体の内部規則等への適合性を有すること、及びセキュリティ上の欠陥、エラー、バグ又は不具合が存しないこと、並びに第三者の権利を侵害しないことについて何ら保証するものではありません。 <br>
        2. 当社は、本サービスにおいて、参画企業の事業へ便宜を与えるツールを提供するものであり、参画企業又は会員の代理人の性質を有さず、会員及び参画企業の間の連絡その他の交渉に関与しないものとします。ただし、本サービス内のメッセージ機能において参画企業が受送信するメッセージの内容につき、本サービスの運用上必要やむを得ない場合には当社がこれを開封する場合があることにつき参画企業は予め同意するものとします。 <br>
        3. 当社が提供するサービスにおいて、他事業者によるサービスへのリンクを利用もしくはサービスとの連携機能を利用する場合には、当該リンク先の正常な表示や連携機能に関して何ら責任を追わないものとします。 <br>
        4. 参画企業は会員に対し、労働基準法その他の労働関係法令等で求められる義務を履行しなければならないものとします。 <br>
        5. 本サービスに関し、参画企業と会員その他の第三者との間で紛争が生じた場合、参画企業は、直ちにその旨を当社に通知するとともに、自己の責任と費用においてこれを解決するものとし、当社はこれに一切関与せず、何ら責任を負わないものとします。 <br>
         <br>
        第１０条（本サービスの変更、追加、廃止及び中断） <br>
        1. 当社は、参画企業に事前に通知することなく、本サービスの内容の全部又は一部を変更又は追加することができます。 <br>
        2. 当社は、事前に、本サービス上又は当社の運営するウェブサイト上への掲示その他当社が適当と判断する方法で参画企業に通知することにより、当社の裁量で、本サービスを終了することができるものとします。ただし、緊急の場合は参画企業への通知を行わないことができるものとします。 <br>
        3. 当社は、以下各号の事由が生じた場合には、参画企業に事前に通知することなく、本サービスの一部又は全部を一時的に中断することができるものとします。 <br>
        (1) 本サービス用の通信機器設備等に関わるメンテナンスや修理を定期的又は緊急に行う場合 <br>
        (2) アクセス過多、その他予期せぬ要因でシステムに負荷が集中した場合 <br>
        (3) 当社のセキュリティを確保する必要が生じた場合 <br>
        (4) 電気通信事業者の役務が提供されない場合 <br>
        (5) 第三者サービスとの連携がある場合、その全部又は一部が提供されない場合 <br>
        (6) 天災等の不可抗力により本サービスの提供が困難な場合 <br>
        (7) 火災、停電、その他の不慮の事故又は戦争、紛争、動乱、暴動、労働争議等により 本サービスの提供が困難な場合 <br>
        (8) 法令又はこれらに基づく措置により本サービスの運営が不能となった場合 <br>
        (9) その他前各号に準じ当社が必要と判断した場合 <br>
        4. 当社は、本条に基づき当社が行った措置により参画企業に生じた損害について一切の責任を負いません。 <br>
         <br>
        第１１条（秘密保持義務） <br>
        1. 参画企業及び当社は、本契約又は本件利用契約に基づき相手方より知り得た事業活動に有用な情報を秘密に保持するものとします。 <br>
        2. 前項の規定は、以下のいずれかに該当する場合は適用しないものとします。 <br>
        (1) 取得した時に既に公知、公用となっているもの <br>
        (2) 取得した後に自己の責によることなく公知、公用となったもの <br>
        (3) 取得する以前に守秘義務を負うことなく既に知得していたもの <br>
        (4) 正当な権利を有する第三者より守秘義務を負うことなく合法的に取得したもの <br>
        (5) 相手方より開示された情報によることなく独自に開発したもの <br>
        3. 第1項にかかわらず、適用ある法令、規則又は裁判所若しくは行政機関等の公的機関の命令、要請等に基づき開示を要求された場合、当該要求を受けた者は、当該要求の範囲内で相手方の秘密情報を開示することができます。但し、この場合、当該要求を受けた者は、当該開示の要求を受けた旨を相手方に対して直ちに通知するものとします。 <br>
         <br>
        第１２条(個人情報) <br>
        1. 参画企業は、本サービスを通じて取得した会員の個人情報その他一切の個人情報を(個人情報保護法第2条第1項に規定するものをいう。)を、厳重に保管・管理するものとします。 <br>
        2. 参画企業は、会員の事前の承諾なく、当該会員の個人情報を第三者に開示、漏洩してはなりません。 <br>
        3. 参画企業は、会員の個人情報を本契約の目的に必要な範囲内でのみ使用するものとし、その他の目的に使用してはなりません。 <br>
        4. 会員の請求があったときは、参画企業は、当該会員の指示に従い、直ちに個人情報が記録された媒体を会員に返還し、又は廃棄するものとします。 <br>
         <br>
        第１３条（反社会的勢力の排除） <br>
        1. 参画企業及び当社は、自己または自己の代理人が、次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。 <br>
        (1) 暴力団、暴力団員、暴力団員でなくなったときから５年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者（以下「暴力団員等」といいます。） <br>
        (2) 暴力団員等が経営を支配していると認められる関係を有すること <br>
        (3) 暴力団員等が経営に実質的に関与していると認められる関係を有すること <br>
        (4) 自己、自社もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること <br>
        (5) 暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること <br>
        (6) 役員または経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること <br>
        2. 参画企業及び当社は、自らまたは第三者を利用して次の各号の一にでも該当する行為を行わないことを確約します。 <br>
        (1) 暴力的な要求行為 <br>
        (2) 法的な責任を超えた不当な要求行為 <br>
        (3) 取引に関して、脅迫的な言動をし、または暴力を用いる行為 <br>
        (4) 風説を流布し、偽計を用いまたは威力を用いて相手方の信用を毀損し、または相手方の業務を妨害する行為 <br>
        (5) その他前各号に準ずる行為 <br>
        3. 参画企業または当社は、相手方が次のいずれかに該当した場合には、何らの催告を要せずして、この契約を解除することができます。 <br>
        (1) 本条1項各号の表明が事実に反することが判明したとき <br>
        (2) 本条1項各号の確約に反して、同項各号のいずれかに該当したとき <br>
        (3) 本条2項各号の確約に反して、同項各号のいずれかに該当する行為を行ったとき <br>
        4. 前項の規定によりこの契約が解除された場合には、解除された者は、その相手方に対し、解除により生じた損害を賠償しなければなりません。 <br>
        5. 第3項の規定によりこの契約が解除された場合には、解除された者は、解除による損害について、その相手方に対し何らの請求もすることができません。 <br>
         <br>
        第１４条（契約の解除） <br>
        1. 当社は、いずれか一方に下記に掲げる各号の一に該当する事由が生じたときは、参画企業は何らの通知、催告を要せず、直ちに本契約の一部もしくは全部を解除することができます。 <br>
        (1) 本契約に基づく履行を怠り、その旨を催告した後14日以内に状況が是正されないとき。 <br>
        (2) 本契約に関して背信行為があったとき。 <br>
        (3) 仮差押え、仮処分、強制執行、担保権の実行、破産手続開始、再生手続開始、更生手続開始、または特別清算開始の申立てがあったとき。 <br>
        (4) 支払停止、または手形交換所の取引停止処分があったとき。 <br>
        (5) 公課公租の滞納処分を受けたとき。 <br>
        (6) その他財産状態が著しく悪化し、またはその恐れがあると認められる相当の事由があるとき。 <br>
        2. 前項に基づく解除の場合、前項の各号の一の事由が生じた者は当然に期限の利益を失い、当社に対して残債務を直ちに履行しなければなりません。 <br>
        3. 本条の規定は、解除した当事者による損害賠償請求を妨げません。 <br>
         <br>
        第１５条（連絡・通知手段） <br>
        1. 本契約の変更に関する通知その他本サービスに関する当社から参画企業への連絡は、当社の運営するウェブサイト内の適宜の場所への掲示、電子メールの送信、その他当社が適当と判断する方法により行うものとします。 <br>
        2. 本サービスに関する問い合わせその他参画企業から当社に対する連絡又は通知は、当社の運営するウェブサイト内の適宜の場所に設置するお問い合わせフォームへの送信その他当社が指定する方法により行うものとします。 <br>
        3. 当社は、参画企業が登録したメールアドレス等に、本サービスに関する広告・宣伝等のメールを配信することができます。 <br>
         <br>
        第１６条（権利義務の譲渡） <br>
        1. 参画企業は、本契約上の地位に基づく一切の権利義務を、当社の事前の書面による承諾なく、第三者に譲渡、貸与又は担保設定その他一切の処分をしてはならないものとします。 <br>
        2. 当社が、本サービスに関する事業を事業譲渡その他の事由(当社が消滅会社又は分割会社 となる合併又は会社分割等により本サービスに係る事業を包括承継させた場合を含みます。)により第三者に承継させる場合には、当該事業の承継に伴い、本契約上の地位、本契約に基づく権利、義務及び参画企業が本サービスに送信した情報その他の情報を当該事業の承継人に譲渡することができるものとし、参画企業は、かかる譲渡について本項において予め同意したものとする。 <br>
         <br>
        第1７条(分離可能性) <br>
        1. 本契約のいずれかの条項又はその一部が、法令等により無効又は執行不能と判断された場合であっても、当該無効又は執行不能と判断された条項又は部分(以下「無効等部分」という。)以外の部分は、継続して完全に効力を有するものとする。参画企業及び当社は、無効等部分を、適法とし、執行力をもたせるために必要な範囲で修正し、無効等部分の 趣旨及び法律的・経済的に同等の効果を確保できるように努めるものとします。 <br>
        2. 本契約のいずれかの条項又はその一部が、ある本契約と同様の契約を締結する第三者 との関係で無効又は執行不能と判断された場合であっても、参画企業との関係における有効性等には影響を及ぼさないものとします。 <br>
         <br>
        第１８条(存続条項) <br>
        条項の性質に鑑み当然 に存続すべき規定は、期間満了、解除、失効、その他理由の如何を問わず本契約が終了したあともその効力を存続します。 <br>
         <br>
        第１９条（協議事項） <br>
        本契約及び本件利用契約に定めのない事項又は本契約及び本件利用契約の条項の解釈等に疑義を生じた場合、参画企業及び当社は誠意をもって協議の上信義に則して解決するものとします。 <br>
         <br>
        第２０条（裁判管轄） <br>
        前条で定める協議をしても解決できない場合、東京地方裁判所を第一審の専属的合意管轄裁判所とするものとします。 <br>
        <br>
        以上<br>
        <br>
        2019年9月1日改定<br>
        2019年8月1日改定<br>
        2019年6月17日改定<br>
        2019年3月18日施行
      </p>
    </main>
  </div>
</template>
<script>
export default {
  name: 'shared_terms'
}
</script>
<style scoped>
.full {
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
}
h1 {
  margin-bottom: 32px;
  text-align: center;
  padding: 0 16px;
  font-size: 30px;
}
.underline-gray {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-weight: 700;
}
@media (max-width: 480px) {
  h1 {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/terms.vue